import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

import { useFailedDomains } from 'features/list';
import { trackEvent } from '../../../helpers/analytics';
import { activeNetworkSelector } from '../../../redux/selectors';
import { useUpdateSharedListMutation } from '../../../services/contacts';

export const useEditCompanyList = (sharedList) => {
  const [update, { isLoading, isError }] = useUpdateSharedListMutation();
  const activeNetwork = useSelector(activeNetworkSelector);
  const initialValues = {
    name: sharedList.name,
    domains: sharedList.domains?.join(',').replace(/,/g, '\n') || '',
  };
  const { setFailedDomains } = useFailedDomains();

  const updateSharedList = async (values) => {
    const { error, data } = await update({
      listId: sharedList.id,
      ...values,
    });

    if (!error) {
      trackEvent('contacts:list:edit_list', {
        collectionId: activeNetwork.id,
        listId: sharedList.id,
        listName: values.name,
        objectType: 'companies',
      });
      toast('List updated', { icon: 'success', id: 'edit-company-list-success' });
    } else if (data?.meta?.failedDomains?.length > 0) {
      setFailedDomains(data?.meta?.failedDomains.map((domain) => domain.domain));
    }
  };

  return { initialValues, updateSharedList, isUpdatingList: isLoading, isError };
};
